import ReservationService from '~/services/ReservationService';

import type { ExistingSurchargeDateBlock } from '~/types/surcharges';

import { reservationQueryKeys } from './reservationQueryKeys';
import { RoomRateInfo, useGroupedByRoomRate } from './useGroupedByRoomRate';

export function useGetExistingSurchargesByRoomRate(
  propertyId: string,
  selectedRoomRates: Array<RoomRateInfo>,
  enabled: boolean,
) {
  return useGroupedByRoomRate<ExistingSurchargeDateBlock>(
    reservationQueryKeys.existingSurchargesByRoomRate(
      propertyId,
      selectedRoomRates.map((rr) => rr.roomRate.id),
    ),
    propertyId,
    selectedRoomRates,
    enabled,
    async (property, roomType, roomRate) => {
      const existingSurchargesResponse = await ReservationService.getSurchargeDates(property, roomType, roomRate);
      return existingSurchargesResponse.result?.dates ?? [];
    },
  );
}
